import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/anquanjiancha/zhenggai.png'
import _imports_1 from '@/assets/anquanjiancha/anquanguanli.png'


const _withScopeId = n => (_pushScopeId("data-v-87db3858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tongji" }
const _hoisted_2 = { class: "echartbox" }
const _hoisted_3 = { class: "echartbox-show" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务总量", -1))
const _hoisted_5 = { class: "progressbox" }
const _hoisted_6 = { class: "showdata" }
const _hoisted_7 = { class: "showdata-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "showdata-title" }, "已审批", -1))
const _hoisted_9 = { class: "showdata-cont" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_11 = { class: "showdata-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "showdata-title" }, "待审批", -1))
const _hoisted_13 = { class: "showdata-cont" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_15 = { class: "showdata-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "showdata-title" }, "待整改", -1))
const _hoisted_17 = { class: "showdata-cont" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_19 = { class: "zhenggaiprogress" }
const _hoisted_20 = { class: "zhenggaiprogress-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_22 = { class: "progressbar" }
const _hoisted_23 = { class: "progressbar-tip" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已整改", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progressbox-title" }, "新增问题分布", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_27 = { class: "progressbar _border" }
const _hoisted_28 = { class: "progressbar-tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_echart_comp = _resolveComponent("echart-comp")!
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, _toDisplayString(_ctx.infodata.totalNum), 1)
      ]),
      _createVNode(_component_echart_comp, { ref: "charts" }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.infodata.closedNum), 1),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.infodata.completedNum), 1),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", null, _toDisplayString(_ctx.infodata.needTodoNum), 1),
            _hoisted_18
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", null, _toDisplayString(_ctx.infodata.closePercent) + "%", 1)
            ]),
            _createVNode(_component_van_progress, {
              "stroke-width": 6,
              percentage: _ctx.infodata.closePercent,
              "show-pivot": false
            }, null, 8, ["percentage"])
          ])
        ])
      ]),
      _hoisted_25,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.itemList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "additem",
          key: index
        }, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", null, _toDisplayString(item.name), 1),
              _createElementVNode("span", null, _toDisplayString(item.number), 1)
            ]),
            _createVNode(_component_van_progress, {
              "stroke-width": 6,
              percentage: item.value,
              "show-pivot": false
            }, null, 8, ["percentage"])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "addbtn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fGoAdd && _ctx.fGoAdd(...args)))
    }, [
      _createVNode(_component_van_icon, { name: "plus" })
    ])
  ]))
}